<div class="modal in hs-composition-warning-dialog" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{'COMMON.warning' | translateHs }}</h4>
                <button type="button" (click)="close()" class="btn-close" data-dismiss="modal"
                    [attr.aria-label]="'COMMON.close' | translateHs">
                </button>
            </div>
            <div class="modal-body" style="max-height: 600px; overflow-y: auto">
                <br>{{'COMMON.name' | translateHs }}: <b>{{data.composition_title}}</b>
                <hr>
                <br>{{data.message}}
                <br>{{'COMPOSITIONS.dialogWarning.toContinue' | translateHs }}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary compositions-btn-warning" (click)="close()"
                    data-dismiss="modal">{{'COMMON.ignoreAndContinue' | translateHs }}</button>
            </div>
        </div>
    </div>
</div>